import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import ContentLoader from "react-content-loader";

const Attraction = ({ records }) => {
  const skeletonRows = Array.from({ length: records });
  return skeletonRows.map((_, rowIndex) => (
    // <div className="col-lg-4 col-md-6" key={rowIndex}>
    //     <a href="javascript:void(0)">
    //         <div className="travelBox">
    //             <ContentLoader
    //                 speed={2}
    //                 width={'100%'}
    //                 height={240}
    //                 viewBox="0 0 356 240"
    //                 backgroundColor="#e0e0d9"
    //                 foregroundColor="#d6d6d0"
    //                 style={{ borderTopLeftRadius: '30px', borderTopRightRadius: '30px' }}
    //             >
    //                 <rect x="0" y="0" rx="30" ry="30" width="100%" height="240" />
    //             </ContentLoader>

    //             <div className="textBox">
    //                 <ContentLoader
    //                     speed={2}
    //                     width={300}
    //                     height={'100%'}
    //                     viewBox="0 0 300 150"
    //                     backgroundColor="#e0e0d9"
    //                     foregroundColor="#d6d6d0"
    //                 >

    //                     <rect x="0" y="0" rx="5" ry="5" width="200" height="15" />

    //                     <rect x="0" y="40" rx="5" ry="5" width="200" height="40" />

    //                     <rect x="0" y="95" rx="5" ry="5" width="75" height="15" />
    //                     <rect x="85" y="95" rx="5" ry="5" width="75" height="15" />
    //                     <rect x="170" y="95" rx="5" ry="5" width="75" height="15" />

    //                     <rect x="0" y="120" rx="5" ry="5" width="100" height="20" />
    //                     <rect x="120" y="120" rx="5" ry="5" width="100" height="15" />
    //                 </ContentLoader>
    //             </div>
    //         </div>
    //     </a>
    // </div>
    <div className="col-lg-4 col-md-6" key={rowIndex}>
      <a href="javascript:void(0)" style={{ width: "100%", height: "100%" }}>
        <div className="travelBox">
          <div className="imgBox skeleton">
            <img loading="lazy" src={""} />
          </div>
          <div className="textBox">
            <p className="oneLine skeleton">
            </p>
            <h6 className="skeleton"></h6>
            <p className="min_height twoLine skeleton">{}</p>
            <ul >
              {
                <li className="skeleton">
                 
                </li>
              }
              {
                <li className="skeleton">
                
                </li>
              }
              {
                <li className="skeleton">
                 
                </li>
              }
            </ul>

            <div className="priceBox ">
              <div className="priceListTag skeleton">
                <h5></h5>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  ));
};
export default Attraction;
